<template>
  <div>
    <navlist :navlist="about" />
    <div class="layout">
      <div class="title">
        <h1>
          社区
          <br />文化
        </h1>
        <h2>{{local.name}}</h2>
      </div>
      <div class="main width">
        <news :swiperSlides="swiperSlides" :id='id' />
      </div>
      
    </div>
  </div>
</template>

<script>
import news from "../components/news";
import navlist from "../components/nav";
import {getArticleList} from '../api/index'
export default {
  components: {
    navlist,
    news
  },
  data() {
    return {
      about: [
        {
          path: "/culture/culture",
          name: "我们的节日"
        },
        {
          path: "/culture/festival",
          name: "文体活动"
        }
      ],
      swiperSlides: [
        
      ],
      local: {},
      id: '',
      action: this.$route.params.id
    };
  },
  created() {
    this.showlocal(this.$route);
    this.getList()
  },
  watch: {
    $route(to) {
      this.showlocal(to);
      this.action = to.params.id
      this.getList()
    }
  },
  methods: {
    showlocal(to) {
      const local = this.about.filter(item => {
        return item.path == to.path;
      });
      this.local = local[0];
      this.id = local[0].path
    },
    async getList(){
      let { action } = this
      let {data} = await getArticleList({action})
      let reg=/<\/?.+?\/?>/g
      this.swiperSlides = data.data
      this.swiperSlides.forEach(item=>{
        item.content = item.content.replace(reg,'')
        var date = new Date(item.create_time*1000)
        var day =  date.getDate()
        var month = (date.getMonth()+1)
        var year = date.getFullYear()
        item['time'] = year+'-'+month +'-'+day
      })
    }
  }
}
</script>

<style>
.width {
  width: 1380px;
  margin-top: 20px !important;
}
</style>